module.exports = __webpack_public_path__ + "img/redo.851c3f36.svg";